import en from './en'
import se from './se'
import tr from './tr'

export default {
	en,
	se,
	tr,
}
